<template>
<span v-if="!corrigido">
    <h3>Documentos Referenciais</h3>
    <b-row>
      <b-col sm="12">
        <p><strong>XI Conferência Nacional dos Direitos da Criança e Adolescente (XI CNDCA),</strong></p>
        <p>Tema: “Proteção Integral, Diversidade e Enfrentamento à Violência”</p>
        <p>A XI CNDCA, convocada por meio da Resolução Nº 202 do Conselho Nacional dos Direitos da Criança e do Adolescente (Conanda), tem por objetivo mobilizar os integrantes do Sistema de Garantia de Direitos - SGD, assim como as próprias crianças, adolescentes e a sociedade em geral, com vistas à construção de propostas voltadas para a afirmação do princípio da proteção integral de crianças e adolescentes nas políticas públicas, fortalecendo as estratégias/ações de enfrentamento às violências e considerando a diversidade.</p>
        <p>A XI Conferência Nacional dos Direitos da Criança e do Adolescente possui os seguintes objetivos estratégicos:</p>
        <ul style="list-style-type: upper-roman">
          <li>Apontar os desafios a serem enfrentados e definir ações para garantir o pleno acesso das crianças e adolescentes às políticas sociais, considerando as diversidades;</li>
          <li>Formular propostas para o enfrentamento das diversas formas de violência contra crianças e adolescentes;</li>
          <li>Propor ações para a democratização, gestão, fortalecimento e participação de crianças e adolescentes nos espaços de deliberação e controle social das políticas públicas;</li>
          <li>Propor ações para a garantia e qualificação da participação e protagonismo de crianças e adolescentes nos diversos espaços: escola, família, comunidade, políticas públicas, sistema de justiça, dentre outros;</li>
          <li>Elaborar ações para garantir a promoção da igualdade e valorização da diversidade na proteção integral de crianças e adolescentes;</li>
          <li>Elaborar propostas para a ampliação do orçamento e aperfeiçoamento da gestão dos fundos para a criança e o adolescente.</li>
        </ul>

        <p>Para atingir os resultados pretendidos, os debates conferenciais foram divididos em cinco eixos temáticos:</p>
        <ul>
          <li>Eixo I: Garantia dos Direitos e Políticas Públicas Integradas e de Inclusão Social;</li>
          <li>Eixo II: Prevenção e Enfrentamento da Violência Contra Crianças e Adolescentes;</li>
          <li>Eixo III: Orçamento e Financiamento das Políticas para Crianças e Adolescentes;</li>
          <li>Eixo IV: Participação, Comunicação Social e Protagonismo de Crianças e Adolescentes;</li>
          <li>Eixo V: Espaços de Gestão e Controle Social das Políticas Públicas de Criança e Adolescentes</li>
        </ul>
        <p>Os documentos base e orientador da XI CNDCA, divulgados pelo Conanda em 2018, são a referência para a organização, metodologia e debates a serem realizados em âmbito local e nacional durante todo o processo conferencial, que foi estruturado em quatro etapas, com início em 2018: conferências livres, municipais, estaduais e distrital e nacional.</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">
        <b-card @click="abrirDocumento('1.pdf')" class="card-button" style="height: 150px; background-color: #48B5DD; font-size: 20px; vertical-align: middle; cursor: pointer;">
          <br>
          <strong>Programação</strong>
        </b-card>
      </b-col>
      <b-col sm="3">
        <b-card @click="abrirDocumento('2.pdf')" class="card-button"  style="height: 150px; background-color: #F05A28;  font-size: 20px; vertical-align: middle; cursor: pointer;">
          <strong>Guia do Participante e Regimento Interno</strong>
        </b-card>
      </b-col>
      <b-col sm="3">
        <b-card @click="abrirDocumento('3.pdf')" class="card-button"  style="height: 150px; background-color: #CD559E;  font-size: 20px; vertical-align: middle; cursor: pointer;">
          <br>
          <strong>Caderno de Propostas</strong>
        </b-card>
      </b-col>
      <b-col sm="3">
        <b-card @click="abrirDocumento('4.pdf')" class="card-button"  style="height: 150px; background-color: #58595B;  font-size: 20px; vertical-align: middle; cursor: pointer;">
          <br>
          <strong>Documento Base</strong>
        </b-card>
      </b-col>
      <b-col sm="3">
        <b-card @click="abrirDocumento('5.pdf')" class="card-button"  style="height: 150px; background-color: #CD559E;  font-size: 20px; vertical-align: middle; cursor: pointer;">
          <br>
          <strong>Documento Orientador</strong>
        </b-card>
      </b-col>
      <b-col sm="3">
        <b-card @click="abrirDocumento('6.pdf')" class="card-button"  style="height: 150px; background-color: #4BBCA7;  font-size: 20px; vertical-align: middle; cursor: pointer;">
          <br>
          <strong>Convocação</strong>
        </b-card>
      </b-col>
      <b-col sm="3">
        <b-card @click="abrirDocumento('7.pdf')" class="card-button"  style="height: 150px; background-color: #58595B;  font-size: 20px; vertical-align: middle; cursor: pointer;">
          <br>
          <strong>Sobre a Modalidade da XI CNDCA</strong>
        </b-card>
      </b-col>
      <b-col sm="3">
        <b-card @click="abrirDocumento('8.pdf')" class="card-button"  style="height: 150px; background-color: #F05A28;  font-size: 20px; vertical-align: middle; cursor: pointer;">
          <br>
          <strong>Orientações 01, 02 e 03</strong>
        </b-card>
      </b-col>
    </b-row>
</span>
</template>
<script>
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  },
  created () {
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  methods: {
    abrirDocumento (documento) {
      window.open(process.env.ROOT_API1 + 'documentos-apoio/' + documento, '_blank')
    }
  }
}
</script>
<style>
.card-button {
  text-align: center;
  border-radius: 15px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/Documentos.vue